"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BuildClass = _interopRequireDefault(require("../BuildClass"));

var _ThemeProvider = require("../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getFilter = function getFilter(_ref) {
  var cssFilter = _ref.cssFilter;
  return {
    filter: cssFilter
  };
};

var UseStyles = function UseStyles(props) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newProps = (0, _ThemeProvider.propValueFromCurrentTheme)(props, options.theme);

  var cmpProps = _objectSpread({}, newProps, {
    options: options
  });

  var classes = (0, _BuildClass["default"])(cmpProps);
  var style = cmpProps.style;
  var styles = Object.assign({}, style, getFilter(props));
  var propTypes = {
    display: _propTypes["default"].string,
    position: _propTypes["default"].string,
    left: _propTypes["default"].string,
    right: _propTypes["default"].string,
    top: _propTypes["default"].string,
    bottom: _propTypes["default"].string,
    margin: _propTypes["default"].string,
    marginRight: _propTypes["default"].string,
    marginLeft: _propTypes["default"].string,
    marginTop: _propTypes["default"].string,
    marginBottom: _propTypes["default"].string,
    marginWidth: _propTypes["default"].string,
    marginHeight: _propTypes["default"].string,
    padding: _propTypes["default"].string,
    paddingRight: _propTypes["default"].string,
    paddingLeft: _propTypes["default"].string,
    paddingTop: _propTypes["default"].string,
    paddingBottom: _propTypes["default"].string,
    paddingWidth: _propTypes["default"].string,
    paddingHeight: _propTypes["default"].string,
    paddingSm: _propTypes["default"].string,
    paddingMd: _propTypes["default"].string,
    paddingLg: _propTypes["default"].string,
    paddingXl: _propTypes["default"].string,
    rounded: _propTypes["default"].string,
    roundedRight: _propTypes["default"].string,
    roundedLeft: _propTypes["default"].string,
    roundedTop: _propTypes["default"].string,
    roundedTopLeft: _propTypes["default"].string,
    roundedTopRight: _propTypes["default"].string,
    roundedBottom: _propTypes["default"].string,
    roundedBottomLeft: _propTypes["default"].string,
    roundedBottomRight: _propTypes["default"].string,
    roundedCircle: _propTypes["default"].bool,
    bgColor: _propTypes["default"].string,
    textColor: _propTypes["default"].string,
    border: _propTypes["default"].bool,
    borderColor: _propTypes["default"].string,
    borderStyle: _propTypes["default"].string,
    borderWidth: _propTypes["default"].string,
    borderTop: _propTypes["default"].bool,
    borderRight: _propTypes["default"].bool,
    borderBottom: _propTypes["default"].bool,
    borderLeft: _propTypes["default"].bool,
    borderNone: _propTypes["default"].bool,
    textAlign: _propTypes["default"].string,
    textTransform: _propTypes["default"].string,
    textTruncate: _propTypes["default"].bool,
    textMonoSpace: _propTypes["default"].bool,
    align: _propTypes["default"].string,
    focusable: _propTypes["default"].bool,
    focusClass: _propTypes["default"].string,
    fontItalic: _propTypes["default"].bool,
    fontWeight: _propTypes["default"].string,
    floatLeft: _propTypes["default"].bool,
    floatRight: _propTypes["default"].bool,
    floatNone: _propTypes["default"].bool,
    cssFilter: _propTypes["default"].string,
    fontName: _propTypes["default"].string,
    fontSize: _propTypes["default"].string,
    fontSizeSm: _propTypes["default"].string,
    fontSizeMd: _propTypes["default"].string,
    fontSizeLg: _propTypes["default"].string,
    fontSizeXlg: _propTypes["default"].string,
    style: _propTypes["default"].objectOf(_propTypes["default"].any),
    shadow: _propTypes["default"].string,
    width: _propTypes["default"].string,
    height: _propTypes["default"].string,
    justifyContent: _propTypes["default"].string,
    hover: _propTypes["default"].string,
    alignSelf: _propTypes["default"].string,
    zIndex: _propTypes["default"].string,
    alignItems: _propTypes["default"].string,
    rtlReverse: _propTypes["default"].bool,
    rotate: _propTypes["default"].bool,
    flexDirection: _propTypes["default"].string,
    flexGrow: _propTypes["default"].string,
    flexShrink: _propTypes["default"].string,
    flex: _propTypes["default"].string,
    flexXs: _propTypes["default"].string,
    flexSm: _propTypes["default"].string,
    flexMd: _propTypes["default"].string,
    flexLg: _propTypes["default"].string,
    linearGradient: _propTypes["default"].string,
    radialGradient: _propTypes["default"].string,
    cursor: _propTypes["default"].string,
    iconColor: _propTypes["default"].string,
    lineHeight: _propTypes["default"].string
  }; // Props validation

  if (process && process.env.NODE_ENV && process.env.NODE_ENV !== "production") {
    _propTypes["default"].checkPropTypes(propTypes, props, undefined, "useStyles");
  }

  return [classes, styles];
};

var _default = UseStyles;
exports["default"] = _default;